import { useState } from "react";
import GoogleMap from "google-map-react";
import { reqGetHost } from "grandus-lib/utils";
import { forEach, mapValues, get, orderBy } from "lodash";

import useWebInstance from "grandus-lib/hooks/useWebInstance";

import dynamic from "next/dynamic";
const OperationUnitCard = dynamic(() =>
  import("components/operationUnits/card/OperationUnitCard")
);

import styles from "./operationUnits.page.module.scss";

const getMapBounds = (map, maps, operationUnits) => {
  const bounds = new maps.LatLngBounds();

  operationUnits.forEach((operationUnit) => {
    bounds.extend(
      new maps.LatLng(operationUnit.latitude, operationUnit.longitude)
    );
  });
  return bounds;
};

// Re-center map when resizing the window
const bindResizeListener = (map, maps, bounds) => {
  maps.event.addDomListenerOnce(map, "idle", () => {
    maps.event.addDomListener(window, "resize", () => {
      map.fitBounds(bounds);
    });
  });
};

// Fit map to its bounds after the api is loaded
const apiIsLoaded = (map, maps, operationUnits) => {
  // Get bounds by our places
  const bounds = getMapBounds(map, maps, operationUnits);
  // Fit map to bounds
  map.fitBounds(bounds);
  // Bind the resize listener
  bindResizeListener(map, maps, bounds);
};

const Marker = ({ show, operationUnit }) => {
  return (
    <>
      <img
        src="/img/marker.svg"
        alt={get(operationUnit, "name", "mobilonline map pin")}
        className={styles?.marker}
      />
      {show ? (
        <div className={get(styles, "marker-detail")}>
          <OperationUnitCard {...operationUnit} />
        </div>
      ) : null}
    </>
  );
};

const Stores = (props) => {
  const { operationUnits } = props;
  const { settings } = useWebInstance();
  const [mapCenter, setMapCenter] = useState([48.6180453, 19.8364996]);
  const [markersPopupShow, setMarkersPopupShow] = useState(() => {
    const initMarkersPopupShow = [];
    forEach(operationUnits, (operationUnit) => {
      initMarkersPopupShow["marker-" + operationUnit?.id] = false;
    });
    return initMarkersPopupShow;
  });

  const onChildClick = (key, { lat, lng }) => {
    const newMarkersPopupShow = mapValues(markersPopupShow, () => false);
    setMarkersPopupShow({
      ...newMarkersPopupShow,
      ...{ [key]: !markersPopupShow[key] },
    });

    // experimental function used for centering marker with infobox - issue: centers marker only, not marker with infobox
    //setMapCenter([toNumber(lat), toNumber(lng)]);
  };

  const sortedOperationUnits = orderBy(operationUnits, "town.name", "asc");
  return (
    <main className={styles.operationUnitContainer}>
      <section className="products">
        <div className="product-listing-grid container">
          <div className="row">
            {sortedOperationUnits.map((operationUnit) => (
              <div
                className="col-xl-3 col-md-6 col-sm-12 column"
                key={`operation-unit-${operationUnit?.id}`}
              >
                <OperationUnitCard {...operationUnit} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export async function getServerSideProps(context) {
  const data = await fetch(
    `${reqGetHost(context?.req)}/api/lib/v1/operation-units?perPage=100`
  ).then((response) => response.json());
  return {
    props: data,
  };
}

export default Stores;
